<app-select [class.include-comparator]="lessThanOrEqualTo() || greaterThanOrEqualTo()" [class.magic-and-rare-only]="!includeNormal() && !includeUnique()"
  [class.prefix-and-text]="!isMobile() && displayMode() === 'prefixAndText'" [class.text-only]="!isMobile() && displayMode() === 'textOnly'"
  [disabled]="disabled()" [displayMode]="isMobile() ? 'iconOnly' : displayMode()" [(ngModel)]="internalModel" (selectedValueChange)="onModelChange($event)">
  @if (includeNormal()) {
    <app-option [value]="Rarity.Normal" [text]="'Normal'" [rarity]="Rarity.Normal" [eq]="lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
    </app-option>
  }
  <app-option [value]="Rarity.Magic" [text]="'Magic'" [rarity]="Rarity.Magic" [lte]="includeNormal() && lessThanOrEqualTo()" [eq]="!includeNormal() && lessThanOrEqualTo()" [gte]="greaterThanOrEqualTo()">
  </app-option>
  @if (includeRare()) {
    <app-option [value]="Rarity.Rare" [text]="'Rare'" [rarity]="Rarity.Rare" [lte]="lessThanOrEqualTo()" [eq]="!includeUnique() && greaterThanOrEqualTo()" [gte]="includeUnique() && greaterThanOrEqualTo()">
    </app-option>
  }
  @if (includeUnique()) {
    <app-option [value]="Rarity.Unique" [text]="'Unique'" [rarity]="Rarity.Unique" [eq]="greaterThanOrEqualTo()" [lte]="lessThanOrEqualTo()">
    </app-option>
  }
</app-select>
